<template>
  <!-- core-lib summary error fixed -->
  <div class="flightResults__shopping container">
    <transition name="searcherTransition" mode="in-out">
      <div
        class="searchForm__container"
        :class="{'searcherForm__open': searcherOpen}"
        v-if="includeSearcher && searcherOpen"
        v-show="searcherOpen"
      >
        <div class="container px-3 pt-3 px-sm-0">
          <searcher
            :showSimpleForm="false"
            :selectedSearchData="$store.getters.getSearchData"
            :renderSpa="'flightresults'"
            :customUrls="{
              base: $store.getters.getConfigUrls ? $store.getters.getConfigUrls.apiBaseUrl : ''
            }"
            :bookingData="searchFlightConfig"
          />
          <button v-if="!shoppingException" class="btn searchForm__btnClose"
                  @click="searcherOpen=false"
          >
            <i class="fas fa-chevron-up"></i>
            <!-- {{ $t('close') }} -->
          </button>
        </div>
      </div>
    </transition>
    <div style="margin-bottom: 100px">
      <component :is="apiVersion === 'v2' ? 'containerCtw': 'containerShoppingLib'"
                 @flightInfo="flightInformation"
                 @selectFlight="selectFlight"
                 @buttonMessageConfig="(v)=>this.buttonMessage.config=v"
                 @areTermsAndConditionsActivated="(terms) => this.termsAndConditions = terms"
                 @openSearcher="() => this.searcherOpen = true"
                 @backCallback="backCallback"
                 @shoppingException="handleShoppingException"
                 @isReturnView="(isReturnView) => isReturn = isReturnView">
      </component>
    </div>
    <FooterMessage
      v-if="showFooterMessage"
      :checkEnabled="buttonMessage.config.check_enabled"
      :api-version="apiVersion"
      @input="handleButtonMessage"
    >
    </FooterMessage>
    <transition name="actionNav" mode="out-in">
      <ActionNav>
        <button class="btn actionNav__back"
                @click="back"
        >
          <i class="fas fa-arrow-left mr-2"></i>
          {{ $t('back_button') }}
        </button>
        <template v-if="showTerms">
          <div class="actionNav__terms">
            <input
              v-model="acceptTerms"
              @input="sendGAClickEvent('terms_and_conditions')"
              type="checkbox"
              class="actionNav__termsInput"
              id="actionNav__termsInput"
            >
            <div class="actionNav__termsWrapper">
              <span class="actionNav__termsContent">
                <span class="actionNav__termsText">{{ $t('terms_text')}}</span>
                <span class="actionNav__termsLink"
                      @click="goTerms"
                >
                  {{ $t('terms_link') }}
                </span>
              </span>
              <label class="actionNav__termsCheck"
                     for="actionNav__termsInput">
                <i class="fas fa-check"></i>
              </label>
            </div>
          </div>
        </template>
        <button v-if="showContinueBtn" class="btn actionNav__continue"
                @click="continueButton"
        >
          {{ $t('continue') }}
          <i class="fas fa-arrow-right ml-2"></i>
        </button>
      </ActionNav>
    </transition>
    <termsAndCondModal
      ref="termsAndCondModal"
      v-model="acceptTerms"
      @onGoTerms="goTerms()"
      @onAcceptTerms="continueButton()"
    />
  </div>
</template>

<script>

import containerShoppingLib from '../views/containerShoppingLib'
import containerCtw from '../views/containerCtw'
import ActionNav from 'core-lib/components/actionNav/ActionNav.vue'
import FooterMessage from 'core-lib/components/FooterMessage/footermessage.vue'
import searcher from 'core-lib/components/searcher/Searcher.vue'
import get from 'lodash/get'
// import axios from 'axios'
import { ItemListView, ItemView, AddToCart, ClickEvent } from 'core/analytics/shopping_kiufare'
import { ItemListViewV2, ItemViewV2 } from 'core/analytics/shopping_atpco'
// import moment from "moment"
import gaMixin from 'core/analytics/ga_mixin'
import { mapFields } from 'vuex-map-fields'
import termsAndCondModal from './terms/TermsAndCondModal'

export default {
  name: 'flightresults',
  components: {
    containerShoppingLib,
    containerCtw,
    ActionNav,
    FooterMessage,
    searcher,
    termsAndCondModal
  },
  mixins: [
    gaMixin
  ],
  inject: ['isDesktopXl'],
  watch: {
    isGoingSelected () {
      if (this.flightsSelected && this.footerCheckAllowed && this.$breakpoint.isDesktop) {
        this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: true })
      }
    },
    'buttonMessage.checked' (checked) {
      if (checked && this.flightsSelected) {
        this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: true })
      }
    }
  },
  data () {
    return {
      isReturn: false,
      shoppingVersion: true,
      includeSearcher: true,
      selectedData: {},
      searcherOpen: false,
      acceptTerms: false,
      buttonMessage: {
        checked: false,
        config: {
          check_enabled: false,
          display: false
        }
      },
      flightInfo: null,
      termsAndConditions: null,
      shoppingException: false
    }
  },
  mounted () {
    this.saveQueryParams()
  },
  methods: {
    saveQueryParams () {
      // KE-4271
      const queryParams = new URLSearchParams(this.$route.query)
      // Delete param's
      queryParams.delete('id_session')
      queryParams.delete('lang')
      queryParams.delete('carrier')
      //  update url history only query params not filtered
      const params = (queryParams.size > 0 ? '?' : '') + queryParams.toString()
      const url = `${window.location.pathname}${params}`
      history.pushState(null, window.location.pathname, url)
    },
    handleButtonMessage (data) {
      this.buttonMessage.checked = data
      this.sendGAClickEvent('flight_results_check_box')
    },
    selectFlight (data) {
      this.selectedData = { ...data }
      this.sendGAItemView(data)
    },
    flightInformation (info) {
      this.flightInfo = info
      const searchData = this.$store.getters.getSearchData
      if (!searchData.country_setting) {
        this.$store.commit('setSearchData', {
          ...this.$store.getters.getSearchData,
          country_setting: {
            currency_code: info.extra_searcher_criteria.display_currency
          }
        })
        this.$store.commit('setGASearchFlight', {
          'trip_type': searchData.return_date ? 'RT' : 'OW',
          'start_date': searchData.departure_date,
          'end_date': searchData.return_date,
          'origin': searchData.origin,
          'destination': searchData.destination,
          'qty_adt': searchData.adults,
          'qty_chd': searchData.minors,
          'qty_inf': searchData.infants,
          'promo_code': searchData.promo_code,
          'client_id': this.$store.getters.getCarrier,
          'currency': info.extra_searcher_criteria.display_currency
        })
      }
      this.sendGAItemListView({ ...info, ...this.$store.getters.getSearchData })
    },
    backCallback () {
      this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: false })
      this.isReturn = false
      this.selectedData = {}
      this.acceptTerms = false
    },
    goTerms: function () {
      this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: false })
      this.$router.push({ name: 'terms' })
    },
    continueButton () {
      // INICIO DE CONDICIONAL PARA MENSAJES
      if (!this.isGoingSelected) {
        return this.showNotifyMessage('select_rate_to_continue')
      }
      if (this.isRoundTrip && !this.isReturnSelected) {
        if (this.isReturn) {
          return this.showNotifyMessage('select_rate_to_continue')
        } else {
          this.$children[0].continueButton()
          return setTimeout(() => {
            window.scrollTo({ top: 0 })
            this.isReturn = true
          }, 500)
        }
      } else if (this.showCheckboxMessage) {
        this.showNotifyMessage('select_check_box_to_continue', 'warning')
        return window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
      } else if (this.showTermsAndConditionMessage) {
        // modificado por tkt KE-3985
        this.showModalTermsCond()
        return
        // return this.showNotifyMessage('select_terms_and_to_continue', 'warning')
      }
      // FIN DE CONDICIONAL PARA MENSAJES
      this.sendGAAddToCart()
      this.$children[0].continueButton()
    },
    showNotifyMessage: function (message, type = 'info') {
      this.$snotify[type](this.$t(message), { position: 'rightTop' })
    },
    back: function () {
      if (this.isRoundTrip) {
        this.$children[0].back()
      } else {
        this.$store.commit('setLoading', true)
        window.location.href = this.$store.getters.getGeneralSettings.ecommerce_setup.logo_redirect_url
      }
    },
    flightAction: async function (shoppingSelected) {
      // const baseUrl = this.$store.getters.getConfigUrls.apiBaseUrl
      // const url = `${baseUrl}flightresults/api/${this.$store.getters.getApiVersion}/action/`
      try {
        // const response = await axios.post(url, shoppingSelected)
        const response = await this.$api.flightsResult.flightAction(this.$store.getters.getApiVersion, shoppingSelected)
        console.log('result:', response.data)
        this.$store.dispatch('goNextSpa')
      } catch (error) {
        console.error('error:', error)
      }
    },
    sendGAItemView (data) {
      try {
        let dataObject = null
        let returnFlight = false

        if (this.apiVersion === 'v2') {
          const key = Object.keys(data).length
          dataObject = data[key]
          if (key > 1) returnFlight = true
        } else {
          returnFlight = get(data.return, 'journeyName')
          dataObject = returnFlight ? data.return : data.going
        }

        const Item = this.apiVersion === 'v2' ? ItemViewV2 : ItemView

        if (this.hasActiveAnalytics) {
          let itemView = new Item(
            !!(returnFlight),
            this.isRoundTrip,
            this.flightResultsAmountPerPax,
            this.$store.getters.getGASearchFlight,
            { ...dataObject, ...this.$store.getters.getSearchData },
            'view_item',
            this.$store.getters.getCarrier,
            this.$store.getters.getSessionId,
            this.getCurrency
          )
          itemView = itemView.process()

          console.table(itemView)
          console.table(itemView.ecommerce.items)

          const price = this.apiVersion === 'v2' ? dataObject.fare.fare_information : dataObject.fare.price

          const { fares_equivalent_paid_by_ptc: faresEquivalentPaidByPt, taxes, fees } = price
          let fares = {}
          let taxesDetail = {}
          let feesDetail = {}

          if (faresEquivalentPaidByPt) fares = this.getAmountsByPassengerType(faresEquivalentPaidByPt, 'amount')
          if (taxes) taxesDetail = this.getAmountsByPassengerType(taxes.taxes_detail, 'total_amount')
          if (fees) feesDetail = this.getAmountsByPassengerType(fees.fees_detail, 'total_amount')

          this.$store.commit('setGAItemView', {
            info: returnFlight ? 'returnFlight' : 'goingFlight',
            ...itemView.ecommerce.items[0],
            fares,
            taxes: taxesDetail,
            fees: feesDetail,
            item_list_id: itemView.ecommerce.item_list_id
          })
        }
      } catch (error) {
        console.log('Error: GAItemView', error)
      }
    },
    sendGAItemListView (info) {
      try {
        if (this.hasActiveAnalytics) {
          try {
            this.$store.commit('clearGAExtraServices')
            this.$store.commit('clearGAItemView')
            const ItemList = this.apiVersion === 'v2' ? ItemListViewV2 : ItemListView
            const itemListView = new ItemList(
              this.flightResultsAmountPerPax,
              this.$store.getters.getGASearchFlight,
              info,
              'view_item_list',
              this.$store.getters.getCarrier,
              this.$store.getters.getSessionId,
              this.getCurrency
            )
            const data = itemListView.process()
            console.table(data)
            console.table(data.ecommerce.items)
          } catch (error) {
            console.log('error', error)
          }
        }
      } catch (error) {
        console.log('Error: GAItemListView', error)
      }
    },
    sendGAAddToCart () {
      try {
        if (this.hasActiveAnalytics) {
          const addToCard = new AddToCart(
            this.$store.getters.getBookingPrices.summaryPrice,
            this.$store.getters.getGAItemView,
            this.$store.getters.getGASearchFlight,
            null,
            'add_to_cart',
            this.$store.getters.getCarrier,
            this.$store.getters.getSessionId,
            this.getCurrency
          )
          const data = addToCard.process()
          console.table(data)
          console.table(data.ecommerce.items)
        }
      } catch (error) {
        console.log('Error: GAAddToCart', error)
      }
    },
    getAmountsByPassengerType (arr, field) {
      const passengerTypeDic = {
        ADULT: 'ADT',
        CHILD: 'CHD',
        INFANT: 'INF'
      }

      return arr.reduce((acc, e) => {
        acc[passengerTypeDic[e.passenger_type]] = e[field]
        return acc
      }, {})
    },
    sendGAClickEvent (eventName) {
      try {
        if (this.hasActiveAnalytics) {
          const clickEvent = new ClickEvent(
            this.$store.getters.getGASearchFlight,
            null,
            eventName,
            this.$store.getters.getCarrier,
            this.$store.getters.getSessionId,
            null
          )

          const data = clickEvent.process()
          console.table(data)
        }
      } catch (error) {
        console.log('Error: Click Event ', eventName, error)
      }
    },
    handleShoppingException () {
      this.shoppingException = true
      this.searcherOpen = true
    },
    showModalTermsCond () {
      this.$refs.termsAndCondModal.showModal()
    }
  },
  computed: {
    ...mapFields(['searchFlightConfig']),
    buttonMessageOk () {
      return (this.buttonMessage.checked === this.buttonMessage.config.check_enabled || !this.buttonMessage.config.display)
    },
    areTermsAndConditionsActivated: function () {
      return this.isShoppingFlow ? this.flightInfo?.configs?.term_condition.term_condition : this.termsAndConditions
    },
    isRoundTrip: function () {
      return this.$store.getters.getSearchData?.return_flight
    },
    showTerms: function () {
      return this.areTermsAndConditionsActivated && (this.apiVersion === 'v1' ? (!this.isRoundTrip || (this.isRoundTrip && this.isReturn)) : this.flightsSelected)
    },
    apiVersion: function () {
      return this.$store.getters.getApiVersion
    },
    flightsSelected: function () {
      return (this.isRoundTrip && this.isReturnSelected) || (!this.isRoundTrip && this.isGoingSelected)
    },
    footerCheckAllowed: function () {
      return !this.buttonMessage.config.check_enabled || this.buttonMessage.checked
    },
    isGoingSelected: function () {
      return get(this.selectedData, 'going.flight', this.selectedData[1])
    },
    isReturnSelected: function () {
      return get(this.selectedData, 'return.flight', this.selectedData[2])
    },
    showFooterMessage: function () {
      if (this.isShoppingFlow) {
        return this.buttonMessage.config.display && this.flightInfo.components.length > 0
      }
      return this.buttonMessage.config.display
    },
    isShoppingFlow: function () {
      return this.apiVersion !== 'v2'
    },
    flightResultsAmountPerPax () {
      return this.ecommerceSetup?.flight_results_amount?.includes('TOTAL AMOUNTS PER ADT')
    },
    ecommerceSetup: function () {
      return get(this.$store.getters.getGeneralSettings, 'ecommerce_setup')
    },
    getCurrency () {
      return this.$store.getters.getSearchData.country_setting.currency_code
    },
    showCheckboxMessage: function () {
      return (this.buttonMessage.config.display && this.buttonMessage.config.check_enabled) && !this.buttonMessage.checked
    },
    showTermsAndConditionMessage: function () {
      return this.showTerms && !this.acceptTerms
    },
    showContinueBtn () {
      return this.apiVersion === 'v1' || this.flightsSelected
    }
  }
}

</script>

<style lang="sass">
.flightResults__shopping
  width: 100%
  padding: 0 !important
.searchForm__container
  box-shadow: var(--z-1)
  z-index: 1000
  position: fixed
  background-color: var(--color-surface)
  transition: width .2s ease
  padding: 0
  top: 3.5rem
  width: 100%
  left: 0
  .container
    position: relative
  .Searcher
    padding: 0
    border: 0
  .--tag
    input, select
      font-size: var(--font-size-xs) !important
  .searchForm__btnClose
    padding: 0
    width: 100%
    border: none
    background-color: var(--color-overlay-05)
    i
      opacity: .6
  .autocompleteAirport, .datepickerInput, .datepickerInput__group, .passengersComponent
    margin-bottom: 0
    input
      height: 2.5rem !important
  .datepickerInput__group, .inputText__group, .inputSelect__group
    height: 2.5rem
  .searchForm__searchBtn
    button.btn
      height: 2.5rem
  .autocompleteAirport__label
    display: none
  .searchForm__formContainer
    box-shadow: none
    padding: 1rem 0 0
  .inputRadio.--row
    .inputRadio__container
      width: auto
  .passengersSelect
    .inputSelect__input
      height: 100%
  .searchForm__datepicker
    margin-bottom: 1rem
.searcherTransition-enter-active, .searcherTransition-leave-active
  transition: all .2s ease
.searcherTransition-enter, .searcherTransition-leave-to
  opacity: 0
  transform: translateY(-1rem)
.dateNoData
  margin-top: 1.5rem
@media (min-width: 768px)
  .flights
    &.--error
      .searchForm__container
        width: 100%
        position: static
        margin: -1.5rem 0 0
        padding:  0 1rem
@media (min-width: 992px)
  .searchForm__container
    padding: 0 1rem
    .searchForm
      &__btnClose
        position: absolute
        right: 0
        top: 0.75rem
        width: auto
        padding: var(--btn-padding-y) var(--btn-padding-x)
      .flightType
        .inputRadio
          margin: .5rem 0
      .countrySettings
        align-items: center
        display: flex
      .--tag
        margin: 0.25rem 0 !important
</style>

<style lang="sass" scoped>
.actionNav__termsContent
  color: var(--color-onNav)
  overflow: hidden

.actionNav__termsText
  -webkit-box-flex: 1
  -ms-flex: 1
  flex: 1
  text-align: right
  overflow: hidden
  max-width: 100%
  text-overflow: ellipsis
  width: fit-content
  white-space: nowrap
</style>
